export default "__VITE_ASSET__937fb9a2__"